import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        "& .MuiFilledInput-root": {
            background: "#ffffff"
        }
    },
    underline: {
        "&&&:before": {
          borderBottom: "none"
        },
        "&&:after": {
          borderBottom: "none"
        }
      }
  });

export default function TextDefault(props) {
    const classes = useStyles()
    
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        props.setValue(value);
    };

    return (
        <div>
           <TextField
                style={{ width: '100%' }}
                id="filled-multiline-static"
                multiline
                rows={4}
                value={props.value}
                onChange={handleChange}
                defaultValue=""
                variant="filled"
                className={classes.root}
                InputProps={{ classes }}
            />
        </div>
    );
}
